/* eslint-disable no-unused-vars */

import _ from 'lodash';
export const checkValueInObjectIsNotEmpty = (data = {}) => {
  if (
    !_.isEmpty(
      Object.values(data)?.filter((x) =>
        _.isString(x) && !_.isEmpty(x) ? x : _.isArray(x?.value) && !_.isEmpty(x?.value) ? x : null
      )
    )
  )
    return true;
  else return false;
};

export const dropdownMenuMap = ({ inspection, category = '', type = '', picklistsMap }) => {
  const {
    pipelineCathodicProtection = [],
    pipelineAssignedBatchingInterval = [],
    pipelineAssignedPiggingInterval = [],
    pipelineStatus = [],
    externalProtection = [],
    internalProtection = [],
    material = [],
    operationsArea = [],
    pipelineReceiverType = [],
    pipelineSenderType = [],
    substance = [],
    pipelineType = [],
    province = [],
    siteStatus = [],
    codeOfConstruction = [],
    areaHierarchy = [],
    equipmentCategoryTypeSubtype = [],
    service = [],
    equipmentStatus = [],
    pSVType = [],
    equipmentValveLocation = [],
    capacity = [],
    concentrationUnits = [],
    largeMeasurement = [],
    smallMeasurement = [],
    pressure = [],
    temperature = [],
    timeUnit = [],
    volume = [],
    pipelineArea = [],
    passFailList = [],
    passDeficiencyFail = [],
    equipmentCategory = [],
    flowRate = [],
    condition = [],
    siteType = [],
    cylinderType = [],
    structureType = [],
    gaugeBoardUOM = [],
    equipmentInsulationMaterial = [],
    constructionMaterial = [],
    psvCategoryTypeAndSubType = [],
    equipmentConnectionType,
    HSEProactiveEffortType = [],
    HSEFocusAreas = [],
    HSEVendors = [],
    functionalGroup = [],
    species = [],
    wildlifeIncidentType = [],
    incidentStatus = [],
    inspectionFrequency = [],
    usersNamesList = [],
    orientationType = []
  } = inspection;
  let list = [];
  list = equipmentCategoryTypeSubtype;

  let dropdownMenuMap = {
    InspFrequencyList: inspectionFrequency,
    PipelineCathodicProtectionPickList: pipelineCathodicProtection,
    ExternalProtectionPickList: externalProtection,
    PipelineAssignedBatchingIntervalPickList: pipelineAssignedBatchingInterval,
    PipelineAssignedPiggingIntervalPickList: pipelineAssignedPiggingInterval,
    PipelineAreaList: areaHierarchy,
    InternalProtectionPickList: internalProtection,
    OperationsAreaPickList: operationsArea,
    MaterialsPickList: material,
    PipelineReceiverTypePickList: pipelineReceiverType,
    PipelineSenderTypePickList: pipelineSenderType,
    PipelineTypePickList: pipelineType,
    PipelineStatusPickList: pipelineStatus,
    SubstancesPickList: substance,
    ProvincesPickList: province,
    SiteTypePickList: siteType,
    AreaList: areaHierarchy,
    SiteStatusPickList: siteStatus,
    EquipmentValveLocationPicklist: equipmentValveLocation,
    ServicesPickList: service,
    EquipmentStatusPickList: equipmentStatus,
    PSVTypePickList: pSVType,
    CodeOfConstructionPickList: codeOfConstruction || [],
    // EquipmentCategoryTypeSubtypePickList: equipmentCategoryTypeSubtype,
    CapacityPickList: capacity,
    ConcentrationUnitsPickList: concentrationUnits,
    LargeMeasurementPickList: largeMeasurement,
    SmallMeasurementPickList: smallMeasurement,
    PressurePickList: pressure,
    TemperaturePickList: temperature,
    TemperaturePicklist: temperature,
    TimeUnitPickList: timeUnit,
    VolumePickList: volume,
    VolumePicklist: volume,
    InspResult_PassFailList: passFailList,
    InspResult_PassDeficiencyFailList: passDeficiencyFail,
    EquipmentCategoryTypeSubtypePickList: list || [],
    FlowRate: flowRate,
    ConditionPickList: condition,
    FlowRatePickList: flowRate,
    CylinderTypePickList: cylinderType,
    ConstructionMaterialPickList: constructionMaterial,
    StructureTypePickList: structureType,
    GaugeBoardUOM: gaugeBoardUOM,
    EquipmentInsulationMaterialPickList: equipmentInsulationMaterial,
    PsvCategoryTypeAndSubTypePickList: psvCategoryTypeAndSubType,
    EquipmentConnectionTypePickList: equipmentConnectionType,
    VendorList: HSEVendors,
    FocusAreasList: HSEFocusAreas,
    FuncGroupList: functionalGroup,
    SpeciesList: species,
    ProactiveEffortTypesList: HSEProactiveEffortType,
    Sighting: wildlifeIncidentType,
    Encounter: wildlifeIncidentType,
    UserList: usersNamesList,
    OrientationTypePickList: orientationType
  };
  return dropdownMenuMap;
};
